import React from 'react';
import { motion } from 'framer-motion';
const scrollToCompra = () => {
  const element = document.getElementById('compra');
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
export function BookHero() {
  return <header className="relative w-full pt-20 pb-16 px-6 md:pt-32 md:pb-24 border-b border-[#1C1917]/10" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-3">
          <span className="inline-block py-1 px-3 border border-[#7F1D1D] text-[#7F1D1D] text-xs font-sans font-bold tracking-widest uppercase mb-6" data-id="element-4">
            Investigación Especial
          </span>

          <h1 className="text-5xl md:text-7xl font-bold text-[#7F1D1D] mb-6 leading-tight tracking-tighter" data-id="element-5">
            Minerales de Sangre
          </h1>

          <h2 className="text-xl md:text-2xl font-serif italic text-[#44403C] mb-12 max-w-2xl mx-auto leading-normal" data-id="element-6">
            El papel de Venezuela en la guerra energética global y el asedio de
            su soberanía
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 1
      }} className="w-16 h-1 bg-[#1C1917] mx-auto mb-12" data-id="element-7" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8,
        ease: 'easeOut'
      }} className="mt-12 relative" data-id="element-8">
          <div className="relative inline-block" data-id="element-9">
            <img src="https://cdn.magicpatterns.com/uploads/7kGQGsUgLcDmyqNmBFwCzq/ChatGPT_Image_Jan_12,_2026,_12_49_54_AM.png" alt="Minerales de Sangre - Portada del libro" className="w-full max-w-md mx-auto shadow-2xl rounded-sm" data-id="element-10" />
            <div className="absolute -top-1 -right-1 bg-[#7F1D1D] text-white rounded-full w-16 h-16 flex items-center justify-center shadow-lg" data-id="element-11">
              <span className="text-[7px] font-bold text-center leading-tight px-1" data-id="element-12">
                AHORA
                <br data-id="element-13" />
                DISPONIBLE
                <br data-id="element-14" />
                ONLINE
              </span>
            </div>
          </div>

          <motion.button initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8,
          duration: 0.6
        }} whileHover={{
          y: -2,
          scale: 1.02
        }} whileTap={{
          y: 0,
          scale: 0.98
        }} onClick={scrollToCompra} className="mt-8 px-8 py-4 bg-[#7F1D1D] text-white font-bold text-lg uppercase tracking-wide rounded-lg shadow-[0_6px_0_0_#5A1414] hover:shadow-[0_4px_0_0_#5A1414] active:shadow-[0_2px_0_0_#5A1414] transition-all duration-150" data-id="element-15">
            ¡Sí! Quiero el Libro
          </motion.button>
        </motion.div>
      </div>
    </header>;
}